<ng-container *transloco="let t">
  <ld-base-modal
    [title]="t('helocDrawProcessingTimeTitle')"
    [size]="'medium'"
    [showCloseButton]="true"
    [closeOnBackdropClick]="false"
    [ariaLabelledBy]="'draw-processing-time-modal-title'"
    (closeModal)="onCancel()"
  >
    <div modal-content>
      <div id="draw-processing-time-content" class="flex flex-col gap-3">
        <p id="draw-processing-time-note" class="text-ld-neutral-600 font-medium m-0">
          {{ t('helocDrawProcessingTimeNote') }}
        </p>
        <p id="draw-processing-time-before-cutoff" class="text-ld-neutral-600 m-0">
          {{ t('helocDrawProcessingTimeBeforeCutoff') }}
        </p>
        <p id="draw-processing-time-after-cutoff" class="text-ld-neutral-600 m-0">
          {{ t('helocDrawProcessingTimeAfterCutoff') }}
        </p>
        <p id="draw-processing-time-weekends" class="text-ld-neutral-600 m-0">
          {{ t('helocDrawProcessingTimeWeekends') }}
        </p>
      </div>
    </div>

    <div modal-footer>
      <button
        id="draw-processing-time-cancel-btn"
        type="button"
        class="btn-outline-ld-purple cursor-pointer"
        (click)="onCancel()"
      >
        {{ t('commonButtonsCancel') }}
      </button>
      <button
        id="draw-processing-time-confirm-btn"
        type="button"
        class="btn-primary-ld-purple cursor-pointer"
        (click)="onConfirm()"
      >
        {{ t('commonButtonsConfirm') }}
      </button>
    </div>
  </ld-base-modal>
</ng-container>
